import Logo from 'common/Components/Logo';
import Layout from 'common/Layouts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormForgetRequst from './components/FormForgetRequst';

function DesktopRequst() {
  const { t } = useTranslation();

  const getTitle = () => {
    const pageName = t(`FormSide.ForgetPasswordText`);
    const brokerName = t(`BrokerCode_${window.api?.BROKER_CODE}.Title`);
    const separateSymbol = ' - ';
    return pageName + separateSymbol + brokerName;
  };

  return (
    <Layout title={getTitle()}>
      <div className="mt-1">
        <Logo />
        <h1 className="text-5xl my-4 text-center text-L-primary-50">
          {t(`FormSide.ForgetPasswordText`)}
        </h1>
        <FormForgetRequst />
      </div>
    </Layout>
  );
}

export default DesktopRequst;
